import "./index.scss";

interface ITrowelAvatar{
    src:string,
    width?: string,
    height?:string;
}

const Avatar : React.FC<ITrowelAvatar>  = ({ src, width, height})=>{

    const iconStyle = {
        backgroundImage: `url(${src})`,
        width,
        height
    };
    return (
        <>
        <div className="trwl-avatar" style={iconStyle}>
        </div>
        </>
    );

};

export default Avatar;